import React, { useState } from 'react'
import { Dialog, DialogSpin } from 'components'
import { Button } from '@mui/material'
import {
  useDisableProceedingMutation,
  successSnack,
  errorSnack,
} from 'features'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

export default function DeleteStudentProceedingsDialog(_props) {
  const {
    togglerComponent: Component = { Button },
    children,
    togglerProps = {},
    proceedingId = '',
    proceedingName = '',
    successCallback = null,
    errorCallback = null,
  } = _props
  const [open, setOpen] = useState(false)

  const dispatch = useDispatch()

  function openDialog(e) {
    e.stopPropagation()
    setOpen(true)
  }
  function closeDialog() {
    setOpen(false)
  }

  const [disableProceeding] = useDisableProceedingMutation()

  async function handleSubmit() {
    try {
      const result = await disableProceeding({
        proceedingid: proceedingId,
      })

      if (result?.data?.message === 'proceeding_disabled') {
        dispatch(
          successSnack({
            message: `Estudiante ${proceedingName} eliminado del lote`,
          })
        )
        closeDialog()
      } else {
        dispatch(
          errorSnack({
            message: 'Error al eliminar del lote',
          })
        )
        closeDialog()
      }
    } catch (error) {
      console.log(error)
      if (errorCallback) errorCallback()
      dispatch(errorSnack({ message: 'Error para eliminadar el lote' }))
      closeDialog()
    }
  }

  return (
    <>
      <Component onClick={openDialog} {...togglerProps}>
        {children}
      </Component>
      {open && (
        <DialogSpin
          open={open}
          handleClose={closeDialog}
          primaryButtonText="Si, eliminar" //Label of the primary button
          secondaryButtonText="Cancelar" // Label of the cancel button
          title={'Eliminar el lote'} // 'Dialog title'
          message={`¿Estás seguro de eliminar el lote ${proceedingName}?'
          \nEste paso no se puede deshacer.`}
          onSubmit={handleSubmit} // Form submit action
        ></DialogSpin>
      )}
    </>
  )
}
